import FormModule from "components/Modules/Documents/FormModule"
import { promotionTypeOptions } from "constants/defaultValues/firebase"
import {
  createOrUpdateFirestoreDocument,
  getFirestoreDocument,
} from "helpers/Firestore"
import React, { useState } from "react"
import ImageWithActionButtons from "../../promotions/_tabs/Types/ImageWithActionButtons"
import Viator from "../../promotions/_tabs/Types/Viator"

const Fields = type => {
  if (type === "ImageWithActionButtons") {
    return ImageWithActionButtons
  }
  if (type === "Viator") {
    return Viator
  }

  return []
}

const CityPartnersForm = ({ opened }) => {
  const [type, setType] = useState()

  return (
    <FormModule
      form={{
        title: "Partners",
        fields: [
          {
            ID: "CF5E0A4F-BF8D-235464-3654-23452435234",
            Type: "Dropdown",
            Name: "Status",
            Label: "Status",
            Required: true,
            GetSelectionOptions: values => {
              return [
                { Name: "Active", ID: "Active" },
                { Name: "Inactive", ID: "Inactive" },
                { Name: "Deleted", ID: "Deleted" },
                { Name: "Unapproved", ID: "Unapproved" },
              ]
            },
          },
          {
            ID: "CF5E0A4F-BF8D-235464-3654-0A1DDD1CC4A1",
            Type: "Dropdown",
            Name: "Type",
            Label: "Type",
            GetSelectionOptions: values => {
              return promotionTypeOptions
            },
            updateValue: (values, val) => {
              setType(val)
              return { ...values, Type: val }
            },
          },
          ...Fields(type),
        ],
        getDefaultValues: async ({ firebaseUID }) => {
          if (!opened) {
            return {}
          }

          const data = await getFirestoreDocument({
            path: `City/Business/Partners/${opened}`,
          })

          setType(data.Type)

          return data
        },
        onSubmit: async (values, { firebaseUID }) => {
          return await createOrUpdateFirestoreDocument({
            path: `City/Business/Partners`,
            values: { Cities: [firebaseUID], ...values },
          })
        },
        onDelete: async ({ firebaseUID }) => {
          return await createOrUpdateFirestoreDocument({
            path: `City/Business/Partners`,
            values: { ID: opened, Status: "Deleted" },
          })
        },
      }}
      ID={opened}
    />
  )
}

export default CityPartnersForm
